import scanTree from './ScanTree';
import parsePath from './ParsePath';
import createElement from './CreateElement';
import { isEmpty, isArray, extend } from './util';
import treeAttribsParser from './TreeAttribsParser';

export default function createNewTree(data, build_element) {
    let self = this;
    let template = (typeof this.vm_template === 'function' && this.vm_template()) || {};
    let components = (typeof this.components === 'function' && this.components()) || {};
    let methods = (this._vm_methods || {});
    let watched = [];
    let deleted = false;
    scanTree(template, function(vnode){
        switch(vnode.tagName) {
            case 'text':
                if (vnode.is_static) {
                    break;
                }
                if (vnode.text && isArray(vnode.text)) {
                    treeAttribsParser(vnode, data, methods, 'text', watched, build_element);
                }
                break;
            case 'div':
                break;
            case 'ul':
                break;
            case 'li':
                break;
            case 'p':
                break;
            case 'span':
                break;
            case 'a':
                break;
            case 'img':
                if (vnode.is_static) {
                    break;
                }
                if (vnode.attribs && vnode.attribs['im-src'] && isArray(vnode.attribs['im-src'])) {
                    let parseredAttribs = {
                        im_src: vnode.attribs['im-src']
                    }
                    treeAttribsParser(parseredAttribs, data, methods, 'im_src', watched, build_element);
                    if (parseredAttribs.im_src) {
                        vnode.src = parseredAttribs.im_src;
                    }
                }
                if (vnode.attribs && vnode.attribs['im-error']) {
                    let error_method = vnode.attribs['im-error'];
                    if (error_method && typeof methods[error_method] === 'function') {
                        vnode.error = methods[error_method];
                    }
                }
                break;
            default:
                if (components && components[vnode.tagName]) {
                    vnode.is_component = true;
                } else {
                    deleted = true;
                }
                break;
        }
        if (deleted) {
            return false;
        }
        if (vnode.className && !vnode.is_static) {
            if (vnode.className && isArray(vnode.className)) {
                treeAttribsParser(vnode, data, methods, 'className', watched, build_element);
            }
        }
        if (build_element) {
            if (vnode.is_component) {
                createElement.call(self, vnode, components);
            } else {
                createElement(vnode, components);
            }
        }
        let parentVnode = vnode;
        if (vnode.children && vnode.children.length) {
            let vnode_children = [];//attribs
            let vnode_children_keys = {};
            for(let child of vnode.children) {
                if (!child.is_static && child.attribs && child.attribs['im-for']) {
                    let for_group_name = child.attribs['im-for'].for_group_name;
                    let for_item_name = child.attribs['im-for'].for_item_name;
                    let v_for_array = parsePath(for_group_name)(data);
                    if (isArray(v_for_array)) {
                        for(let item of v_for_array) {
                            let _data = {
                                ...data
                            }
                            _data[for_item_name] = item;
                            if (child.attribs['im-item']) {
                                child.v_item = {};
                                child.v_item[child.attribs['im-item']] = item;
                            } else {
                                child.v_item = item;
                            }
                            if (child.attribs['im-key'] && isArray(child.attribs['im-key'])) {
                                let parseredAttribs = {
                                    im_key: child.attribs['im-key']
                                }
                                treeAttribsParser(parseredAttribs, _data, methods, 'im_key');
                                if (!isEmpty(parseredAttribs.im_key)) {
                                    child.key = parseredAttribs.im_key;
                                }
                            }
                            let _child_pushed = extend(true, {}, child);
                            _child_pushed.attribs['im-for'] = null;
                            delete _child_pushed.attribs['im-for'];
                            if (!isEmpty(_child_pushed.key) && vnode_children_keys[_child_pushed.key]) {

                            } else {
                                vnode_children_keys[_child_pushed.key] = true;
                                vnode_children.push(_child_pushed);
                            }
                        }
                        if (build_element) watched.push(for_group_name);
                    }
                } else if (!child.is_static && child.attribs && child.attribs['im-key'] && isArray(child.attribs['im-key'])) {
                    let parseredAttribs = {
                        im_key: child.attribs['im-key']
                    }
                    let _data = {
                        ...data
                    }
                    treeAttribsParser(parseredAttribs, _data, methods, 'im_key', watched, build_element);
                    if (!isEmpty(parseredAttribs.im_key)) {
                        child.key = parseredAttribs.im_key;
                    }
                    if (!isEmpty(child.key) && vnode_children_keys[child.key]) {

                    } else {
                        vnode_children_keys[child.key] = true;
                        vnode_children.push(child);
                    }
                } else {
                    vnode_children.push(child);
                }
            }
            vnode.children = vnode_children;
            for(let child_index = 0; child_index < vnode.children.length; child_index++) {
                let child = vnode.children[child_index];
                child.parentVnode = parentVnode;
                if (!child.is_static && child.attribs && child.attribs['im-if']) {
                    child.is_if = parsePath(child.attribs['im-if'])(data);
                    if (!child.is_if) {
                        vnode.children.splice(child_index, 1);
                        child_index--;
                    }
                    if (build_element) watched.push(child.attribs['im-if']);

                }
                if (!child.is_static && child.attribs && child.attribs['im-show']) {
                    child.is_show = !!parsePath(child.attribs['im-show'])(data);
                    if (build_element) watched.push(child.attribs['im-show']);
                }
                if (!child.is_static && child.attribs && child.attribs['im-html']) {
                    child.inner_html = parsePath(child.attribs['im-html'])(data) || '';
                    if (build_element) watched.push(child.attribs['im-html']);
                }
                if (!child.is_static && child.attribs && child.attribs['im-key'] && isArray(child.attribs['im-key'])) {
                    
                }
            }
        }
        return true;
    });

    return {
        template,
        watched
    };
}